export enum RestrictionStatusDroneOperatorColorEnum {
    RESTRICTION_UNKNOWN = 'medium',
    RESTRICTION_CREATED = 'medium',
    RESTRICTION_REMOVED = 'medium',
    RESTRICTION_PENDING_ACCEPTANCE = 'warning',
    RESTRICTION_PENDING_REVIEW = 'activated',
    RESTRICTION_ACCEPTED = 'success',
    RESTRICTION_APPROVED = 'zomp',
    RESTRICTION_BLOCKING = 'redsalsa',
}